import { BREAKPOINTS } from "../config/breakpoints";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
	display: flex;
	position: ${(props) => props.position};
	flex-direction: ${(props) => props.flexDirection};
	justify-content: ${(props) => props.jContent};
	font-family: ${(props) => props.fontFamily};
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	box-shadow: ${(props) =>
		props.border ? "" : props.boxShadow};
	border-radius: ${(props) => props.borderRadius};
	align-items: ${(props) => props.alignItems};
	height: ${(props) => props.height};
	width: ${(props) => props.width};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	flex-wrap: ${(props) => props.flexWrap};
	overflow-x: ${(props) => props.overflowX};
	float: ${(props) => props.float};
	opacity: ${(props) => (props.disabled ? "0.7" : props.opacity)};
	pointer-events: ${(props) => (props.disabled ? "none" : props.pointerEvents)};
	transition: 0.6s all ease-in-out;
	border: ${(props) => props.border};
  	gap:${(props) => props.gap};
	&:hover {
		box-shadow: ;
	}
	@media (min-width: ${BREAKPOINTS.desktop}px) {
		width: ${(props) => props.widthAfter1000};
	}

    @media (max-width: ${BREAKPOINTS.tablet}px) {
        width: 100%;
        padding: 1rem;
    }

    @media (max-width: ${BREAKPOINTS.mobile}px) {
        padding: 0.5rem;
    }
`;

Container.defaultProps = {
	flexDirection: "column",
	background: "#fff",
	borderRadius: "20px",
	alignItems: "center",
	height: "max-content",
	width: "max-content",
	padding: "2rem",
	margin: "",
	boxShadow: "",
	flexWrap: "nowrap",
	position: "relative",
};

//0px 1px 17px -8px rgba(0,0,0,1)

const Card = (props) => {
	return (
		<Container ref={props.innerRef} id={props.id} {...props}>
			{props.children}
		</Container>
	);
};

export default Card;
